var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: style */
function SvgPlug(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 0 48 48"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    id: "plug_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement(Path, {
    id: "plug_svg__invisible_box",
    fill: "none",
    stroke: "none",
    d: "M0 0h48v48H0z",
    "data-name": "invisible box"
  }), /*#__PURE__*/React.createElement(Path, {
    id: "plug_svg__Layer_6",
    d: "M25.6 25.6L22.2 29 19 25.8l3.4-3.4a2 2 0 00-2.8-2.8L16.2 23l-1.3-1.3a1.9 1.9 0 00-2.8 0l-3 3a9.8 9.8 0 00-3 7 9.1 9.1 0 001.8 5.6l-3.3 3.3a1.9 1.9 0 000 2.8 1.9 1.9 0 002.8 0l3.2-3.2a10.1 10.1 0 005.9 1.9 10.2 10.2 0 007.1-2.9l3-3a2 2 0 00.6-1.4 1.7 1.7 0 00-.6-1.4L25 31.8l3.4-3.4a2 2 0 00-2.8-2.8zm-4.8 10.8a6.1 6.1 0 01-8.5 0l-.4-.4a6.4 6.4 0 01-1.8-4.3 6 6 0 011.8-4.2l1.6-1.6 8.8 8.9zM43.4 4.6a1.9 1.9 0 00-2.8 0L37.2 8a10 10 0 00-13 .9l-3 3a2 2 0 00-.6 1.4 1.7 1.7 0 00.6 1.4l11.7 11.7a1.9 1.9 0 002.8 0l3-2.9a9.9 9.9 0 002.9-7.1 10.4 10.4 0 00-1.6-5.5l3.4-3.5a1.9 1.9 0 000-2.8zm-7.5 16l-1.6 1.6-8.9-8.9 1.6-1.5a5.9 5.9 0 018.5 0l.4.3a6.3 6.3 0 011.7 4.3 5.9 5.9 0 01-1.7 4.2z",
    "data-name": "Layer 6"
  }))));
}
export default SvgPlug;